/**
 * @author PoornaChandu
 */
import React, { Fragment, useState, useEffect } from 'react';
import { Input, Select, Popover, Col, Row, TimePicker, message, Button } from 'antd';
import moment from 'moment';
import HierarchyModal from '../utils/HierarchyModal';
import {
  Boxdiv,
  StyledAppdiv,
  StyledModal,
  RuleTypeSelectionDiv,
  BlockedLabelBlack,
  ConditionSelect,
  ActionSelectionDiv,
  // AddParagraph,
  LogicAddButton,
  BlankDiv,
  DeviceSelect,
  ParameterSelect,
  TagNameSelect,
  OperaterSelect,
  ValueInput,
  ButtonBoxDiv,
  // PickyStyling,
  MarginRightButton,
  OnchangeCheckbox,
  ActionCheckbox,
  TextParagraph
  // AddParagraph
  // BlockedParaBlack
} from '../style';
import { actionList } from '../utils/const';
import { getCommunicationList, getRuleType, getUserprofiles, recipientListAPI } from '../Apicalls';
import constants from '../constants';
import localStorage from '../../../utils/localStorage';
// import 'antd/lib/date-picker/style/css';
import {
  CheckCircleOutlined,
  DeleteOutlined,
  ApartmentOutlined,
  UpSquareOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
const { Option } = Select;
const { TextArea } = Input;
const Operator = [
  {
    key: 'EqualTo (==)',
    value: '=='
  },
  {
    key: 'Not EqualTo (!=)',
    value: '!='
  },
  {
    key: 'Greater Than (>)',
    value: '>'
  },
  {
    key: 'Less Than (<)',
    value: '<'
  },
  {
    key: 'Greater Than Or EqualTo (>=)',
    value: '>='
  },
  {
    key: 'Less Than Or EqualTo (<=)',
    value: '<='
  }
];
// export default function DeviceRuleView(props) {
const DeviceRule = (props) => {
  const [recipientList, setRecipientList] = useState([]);
  // const [ItemdataSource, setItemdataSource] = useState([]);
  const [treeVisible, setTreeVisible] = useState(false);
  const [visibleTree, setVisibleTree] = useState(false);
  const [communicationType, setCommunicationType] = useState([]);
  // const [value, setValue] = useState([]);
  const [data, setData] = useState([]);
  // const [translationAction, setTranslationAction] = useState([]);
  const [checkedValue, setCheckedValue] = useState([]);
  const [ruleTypeList, setRuleTypeList] = useState([]);
  // const [selectHierachyLevel, setSelectHierachyLevel] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  // const [DeviceData, setDeviceData] = useState([]);
  // const [enable, setEnable] = useState(props.enable || '');
  const [selectedHierarchy, setSelectedHierarchy] = useState([]);
  const [edit, setEdit] = useState(props.edit || false);
  // const [checkedArray, setCheckedArray] = useState([]);
  // const [originalCheckedArray, setOriginalCheckedArray] = useState([]);
  const [hierarchyDefault, setHierarchyDefault] = useState(undefined);
  const { handleSelectHierarchy, handledeviceSelect, handlePickyChange } = props.Methods;

  useEffect(() => {
    const fetchData = async () => {
      let commlist = await getCommunicationList();
      let ruleTypeList = await getRuleType();

      let communicationTypeList =
        commlist?.data?.map((item) => {
          let val = item.Code;
          let t1 = communicationType.push(val);
          return t1;
        }) || [];
      let filteredActionList = getList(communicationTypeList);
      let recipientData = await recipientListAPI();
      let userProfileData = await getUserprofiles();
      let HierachyLevels =
        userProfileData?.belongsTo?.sites?.[localStorage.get('currentSite')]?.hierarchy || [];
      let hierarchyDefault = HierachyLevels[0]?.HierarchyCode;

      handleSelectHierarchy(hierarchyDefault, 0, 'inputList', 'initail');
      // setEnable(true);
      setData(filteredActionList);
      setCommunicationType(communicationTypeList);
      setRuleTypeList(ruleTypeList);
      setSelectedHierarchy(HierachyLevels);
      setRecipientList(recipientData?.data || []);
      setHierarchyDefault(hierarchyDefault);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (props.userProfile !== userProfile || props.edit !== edit) {
      setEdit(props.edit);
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile, props.edit]);
  const getList = () => {
    let filteredArray = [];
    filteredArray = communicationType.map((comm) => {
      return actionList.filter((action) => action.value === comm);
    });
    let data = [];
    filteredArray.map((item) => {
      return item.map((val) => {
        return data.push(val);
      });
    });
    return data;
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache?.[keyword] || keyword;
  };
  const hierarchyDropdownChange = (value) => {
    let { indexDevice } = props;
    handledeviceSelect(value.Code, 'inputList', indexDevice);
    setTreeVisible(false);
    // setReplicateDevices(value);
  };
  // const onModalOk = () => {
  //   setTreeVisible(false);
  // };
  const onModalCancel = () => {
    setTreeVisible(false);
  };
  const hierarchyDropdownChanged = (value) => {
    setCheckedValue(value);
  };

  const onModalsOk = (e) => {
    e.preventDefault();
    handlePickyChange(checkedValue);
    setVisibleTree(false);
    // setSelectedDevices(replicateDevices);
  };
  const onTree = (arr) => {
    if (arr && Array.isArray(arr)) {
      return arr.map((obj) =>
        obj && Array.isArray(obj.children)
          ? { ...obj, children: onTree(obj.children) }
          : { ...obj, checkable: true }
      );
    }
    return arr;
  };

  // translation = (keyword) => {
  //   let { translationCache } = this.props;
  //   return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  // };
  const { config, Methods, translationCache } = props;
  const {
    inputList,
    conif,
    conelseif,
    conelse,
    elsifLength,
    elseList,
    ruleType,
    mailRecipients,
    NumberOfNotifications,
    rulebody,
    url,
    deviceList,
    downtimeinputList,
    onChange,
    onContinous,
    previsible,
    rootCause,
    recommandationStatus,
    elseprevisible,
    elseroot,
    elserecommandation,
    replicateDevices,
    parametersList,
    // parameterChangeList,
    disabledParamTypeDevice,
    selectedDevices
    // edit
  } = config;
  const {
    // handledeviceSelect,
    handleParameterSelect,
    // handleSelectHierarchy,
    // handleelseif,
    // handleelse,
    handleDelay,
    handleFrequency,
    checkonChange,
    handleTagSelect,
    handleInputChange,
    handleAddClick,
    handleRuleType,
    handleRecipientList,
    handleNotificationChange,
    handleRulebody,
    handleurl,
    // handlePickyChange,
    handleRadioButton,
    handleContinous,
    handleRemoveClick,
    handleVisibleChange,
    handlePopoverOnclick,
    handleTextAreaChange,
    handleConditionchange
    // handleparameterTypeSelect
  } = Methods;
  return (
    <StyledAppdiv>
      <RuleTypeSelectionDiv>
        <div style={{ marginRight: '12%', marginLeft: '10px' }}>
          <BlockedLabelBlack>{translation(constants.type)}</BlockedLabelBlack>
          <Select
            placeholder="ruleType"
            style={{ width: '120px', display: 'inline-block' }}
            value={ruleType}
            onChange={(value) => {
              handleRuleType(value, 'ruleType');
            }}>
            {ruleTypeList &&
              Array.isArray(ruleTypeList) &&
              ruleTypeList.map((ruleType, index) => (
                <Option key={index} value={ruleType.Code} title={translation(ruleType.Description)}>
                  {translation(ruleType.Name)}
                </Option>
              ))}
          </Select>
        </div>
        {ruleType === 'batch' && (
          <div style={{ marginRight: '12%', marginTop: '5px' }}>
            <label style={{ display: 'block', color: 'white' }}>
              {translation(constants.priority)}
            </label>
            <Select
              placeholder={translation(constants.priority)}
              style={{ width: '120px', display: 'inline-block' }}
              value={props.batchPriority === '' ? undefined : props.batchPriority}
              onChange={(value) => {
                handleRuleType(value, 'batchPriority');
              }}>
              {Array.isArray(config.priorityTypes) &&
                config.priorityTypes.map((type, index) => (
                  <Option key={index} value={type.PriorityType}>
                    {type.PriorityType}
                  </Option>
                ))}
            </Select>
          </div>
        )}
        {ruleType === 'downTime' && (
          <>
            <div style={{ marginRight: '12%', marginTop: '5px' }}>
              <label style={{ display: 'block', color: 'white' }}>
                {translation(constants.device)}
              </label>
              <DeviceSelect
                placeholder={translation(constants.device)}
                value={props.selectedDevices || downtimeinputList.device}
                onChange={(value) => handledeviceSelect(value, 'downtimeinputList')}>
                {deviceList &&
                  Array.isArray(deviceList) &&
                  deviceList.map((device, i) => (
                    <Option key={`ifdeviceList${i}`} value={device.AliasCode}>
                      {device.Name}
                    </Option>
                  ))}
              </DeviceSelect>
            </div>
            <div>
              <ActionSelectionDiv>
                <BlockedLabelBlack>
                  {translation(constants.action)}
                  <span style={{ color: 'red' }}>*</span>
                </BlockedLabelBlack>
                <ActionCheckbox
                  options={data}
                  value={downtimeinputList['action']}
                  onChange={(checkedValues) => {
                    checkonChange(checkedValues, 'downtimeinputList');
                  }}
                />
                <Popover placement="top" title={'Delay'}>
                  <TimePicker
                    style={{ margin: '10px' }}
                    defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                    value={
                      downtimeinputList['delay'] === undefined
                        ? dayjs('00:00:00', 'HH:mm:ss')
                        : dayjs(downtimeinputList['delay'][1], 'HH:mm:ss')
                    }
                    onChange={(e) => handleDelay(e, 'downtimeinputList')}
                    placeholder={translation(constants.selectDelay)}
                    allowClear={false}
                  />
                </Popover>
                <Popover placement="top" title={'Frequency'}>
                  <TimePicker
                    // disabled={!onContinous}
                    style={{ margin: '10px' }}
                    defaultOpenValue={moment('00:00:00', 'HH:mm:ss')}
                    value={
                      downtimeinputList['frequency'] === undefined
                        ? moment('00:00:00', 'HH:mm:ss')
                        : moment(downtimeinputList['frequency'][1], 'HH:mm:ss')
                    }
                    onChange={(e) => handleFrequency(e, 'downtimeinputList')}
                    placeholder={translation(constants.selectFrequency)}
                    allowClear={false}
                  />
                </Popover>
                {config &&
                  config.inputList &&
                  config.inputList[config.inputList.length - 1].action.indexOf('RestAPI') > -1 && (
                    <Input
                      style={{ width: '55%', marginTop: '2%' }}
                      placeholder="Enter Url"
                      name="value"
                      value={url}
                      onChange={(e) => handleurl(e, 'url')}
                    />
                  )}
              </ActionSelectionDiv>
            </div>
          </>
        )}
        {ruleType !== 'downTime' && (
          <div
            style={{
              width: '350px',
              display: 'flex',
              justifyContent: 'flex-start',
              flexFlow: 'row wrap'
            }}>
            <BlockedLabelBlack>{translation(constants.replicate)}</BlockedLabelBlack>
            <span
              style={{
                width: '350px',
                display: 'flex',
                justifyContent: 'flex-start',
                flexFlow: 'row wrap'
              }}>
              <Select
                value={replicateDevices}
                disabled={true}
                mode="multiple"
                style={{ width: '70%', color: 'black' }}
                placeholder="Select Item..."
                maxTagCount="responsive">
                {deviceList &&
                  deviceList.map((device, i) => (
                    <Option key={`ifdeviceList${i}`} value={device.AliasCode}>
                      {translation(device.Name)}
                    </Option>
                  ))}
              </Select>
              <Button
                type="primary"
                style={{ width: '15%' }}
                onClick={() => {
                  if ((selectedDevices && selectedDevices.length > 0) || edit === true) {
                    setVisibleTree(true);
                  } else {
                    setVisibleTree(false);
                    message.error('Please Select Equipment');
                  }
                }}>
                <UpSquareOutlined />
              </Button>
            </span>
          </div>
        )}
        {ruleType !== 'downTime' && (
          <OnchangeCheckbox
            checked={onChange}
            disabled={onContinous}
            onChange={(value) => handleRadioButton(value)}>
            {translationCache && translationCache[`${constants.onchange}`]
              ? translationCache[`${constants.onchange}`]
              : `${constants.onchange}`}
          </OnchangeCheckbox>
        )}
      </RuleTypeSelectionDiv>
      {ruleType !== 'downTime' ? (
        <>
          {conif
            ? inputList &&
            inputList.map((x, i) => {
              return (
                <Boxdiv key={`if${i}`}>
                  {i === 0 ? (
                    <div style={{ display: 'block' }}>
                      <BlockedLabelBlack>{`if`}</BlockedLabelBlack>
                    </div>
                  ) : null}
                  {i > 0 && (
                    <div style={{ marginRight: '10px 0px' }}>
                      <ConditionSelect
                        name="operater"
                        style={{ marginBottom: '25px' }}
                        placeholder={
                          translationCache && translationCache[`${constants.selectCondition}`]
                            ? translationCache[`${constants.selectCondition}`]
                            : `${constants.selectCondition}`
                        }
                        value={x['54765'] === '' ? undefined : x['54765']}
                        onChange={(e) => handleConditionchange(e, i, 'inputList')}>
                        <Option value="&&">AND</Option>
                        <Option value="||">OR</Option>
                      </ConditionSelect>
                    </div>
                  )}
                  <ParameterSelect
                    disabled={edit || (inputList.length > 1 && !edit)}
                    name="parameterName"
                    placeholder={
                      translationCache && translationCache[`${constants.ParameterType}`]
                        ? translationCache[`${constants.ParameterType}`]
                        : `${constants.ParameterType}`
                    }
                    value={translation(props.parameterName)}
                    onChange={(value) => {
                      handleParameterSelect(value, i, 'inputList');
                      handleSelectHierarchy(
                        x && x.HierarchyId === undefined ? hierarchyDefault : x.HierarchyId,
                        i,
                        'inputList',
                        value
                      );
                    }}>
                    {props.parameterChangeList &&
                      Array.isArray(props.parameterChangeList) &&
                      props.parameterChangeList.map((parameter, j) => (
                        <Option key={`ifdeviceList${j}`} value={parameter.ParameterType}>
                          {parameter.ParameterType}
                        </Option>
                      ))}
                  </ParameterSelect>
                  <ParameterSelect
                    disabled={edit || (inputList.length > 1 && !edit)}
                    name="selectedHierarchy"
                    onChange={(value) =>
                      handleSelectHierarchy(
                        value,
                        i,
                        'inputList',
                        x.parameterName === '' ? undefined : x.parameterName
                      )
                    }
                    placeholder={
                      translationCache && translationCache[`${constants.selectHierarchy}`]
                        ? translationCache[`${constants.selectHierarchy}`]
                        : 'Please select hierarchy'
                    }
                    value={x && x.HierarchyId === undefined ? hierarchyDefault : x.HierarchyId}>
                    {selectedHierarchy &&
                      Array.isArray(selectedHierarchy) &&
                      selectedHierarchy.map((item, j) => (
                        <Option key={j} value={item.HierarchyCode}>
                          {item.HierarchyName}
                        </Option>
                      ))}
                  </ParameterSelect>
                  <DeviceSelect
                    placeholder={
                      translationCache && translationCache[`${constants.device}`]
                        ? translationCache[`${constants.device}`]
                        : `${constants.device}`
                    }
                    value={translation(props.selectedDevices || x.device)}
                    disabled={true}
                    suffixIcon={
                      <ApartmentOutlined
                        style={{
                          color: '#1a3b5c',
                          cursor: disabledParamTypeDevice ? 'not-allowed' : 'pointer',
                          opacity: disabledParamTypeDevice ? '0.3' : '1'
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (edit || (inputList.length > 1 && !edit)) {
                            setTreeVisible(false);
                          } else {
                            if (inputList && inputList[i] && !inputList[i].parameterName) {
                              setTreeVisible(false);
                              message.error('Please Select ParameterType');
                            } else {
                              setTreeVisible(true);
                            }
                          }
                        }}
                      />
                    }>
                    {deviceList &&
                      Array.isArray(deviceList) &&
                      deviceList.map((device, j) => (
                        <Option key={`ifdeviceList${j}`} value={device.AliasCode}>
                          {translation(device.Name)}
                        </Option>
                      ))}
                  </DeviceSelect>
                  <TagNameSelect
                    showSearch
                    name="tagName"
                    placeholder={
                      translationCache && translationCache[`${constants.selectparameters}`]
                        ? translationCache[`${constants.selectparameters}`]
                        : `${constants.selectparameters}`
                    }
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    value={x.tagName === '' ? undefined : translation(x.tagName)}
                    onChange={(e) => handleTagSelect(e, i, 'inputList')}>
                    {parametersList &&
                      Array.isArray(parametersList) &&
                      parametersList.filter(
                        (param) =>
                          param.ParameterDescription && param.ParameterDescription.trim() !== ''
                      ).map((param, j) => (
                        <Option key={`inputTagname${i}${j}`} value={param.ParameterCode}>
                          {translation(param.ParameterDescription)}
                        </Option>
                      ))}
                  </TagNameSelect>
                  <OperaterSelect
                    name="operater"
                    placeholder={
                      translationCache && translationCache[`${constants.selectoperator}`]
                        ? translationCache[`${constants.selectoperator}`]
                        : `${constants.selectoperator}`
                    }
                    value={x.operater === '' ? undefined : x.operater}
                    onChange={(e) => handleInputChange(e, i, 'select', 'inputList')}>
                    {Operator &&
                      Array.isArray(Operator) &&
                      Operator.map((item, index) => {
                        return (
                          <>
                            {inputList[i].parameterName === 'Operational' ? (
                              <Option key={index} value={item.value}>
                                {item.key}
                              </Option>
                            ) : null}
                          </>
                        );
                      })}
                    {inputList[i].parameterName !== 'Operational' ? (
                      <Option value="==" title="EqualTo">
                        {`EqualTo (==)`}
                      </Option>
                    ) : null}
                  </OperaterSelect>
                  <ValueInput
                    name="value"
                    maxLength={6}
                    placeholder={
                      translationCache && translationCache[`${constants.value}`]
                        ? translationCache[`${constants.value}`]
                        : `${constants.value}`
                    }
                    value={x.value}
                    onChange={(e) => handleInputChange(e, i, 'input', 'inputList')}
                  />
                  {inputList.length !== 1 && (
                    <MarginRightButton onClick={() => handleRemoveClick(i, 'inputList')}>
                      <DeleteOutlined />
                    </MarginRightButton>
                  )}
                  {inputList.length - 1 === i && (
                    <LogicAddButton
                      type={'primary'}
                      onClick={() => handleAddClick('inputList', ruleType)}>
                      {translationCache && translationCache[`${constants.add}`]
                        ? translationCache[`${constants.add}`]
                        : `${constants.add}`}
                    </LogicAddButton>
                  )}
                  <ButtonBoxDiv>
                    {inputList.length - 1 === i && (
                      <Fragment>
                        <Popover
                          content={
                            <div>
                              <TextArea
                                value={
                                  inputList[i] && inputList[i]['preventive']
                                    ? inputList[i]['preventive']
                                    : ''
                                }
                                rows={5}
                                maxLength="150"
                                onChange={(e) =>
                                  handleTextAreaChange(e, i, 'inputList', 'preventive')
                                }
                              />
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                onClick={() => {
                                  handlePopoverOnclick(
                                    i,
                                    'inputList',
                                    'close',
                                    'preventive',
                                    'previsible'
                                  );
                                }}>
                                {translation('Cancel')}
                              </span>
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                onClick={() => {
                                  handlePopoverOnclick(i, 'inputList', 'ok', 'previsible');
                                }}>
                                {translation('Ok')}
                              </span>
                            </div>
                          }
                          open={previsible}
                          onOpenChange={(value) => handleVisibleChange(value, 'previsible')}
                          title={
                            translationCache && translationCache[`${constants.preventivemeasure}`]
                              ? translationCache[`${constants.preventivemeasure}`]
                              : `${constants.preventivemeasure}`
                          }
                          trigger="click">
                          <TextParagraph>
                            {translationCache &&
                              translationCache[`${constants.preventivemeasure}`]
                              ? translationCache[`${constants.preventivemeasure}`]
                              : `${constants.preventivemeasure}`}
                          </TextParagraph>
                          {inputList[i]['preventive'] &&
                            inputList[i]['preventive'].length > 0 && (
                              <span style={{ color: '#60c40e' }}>
                                <CheckCircleOutlined />
                              </span>
                            )}
                        </Popover>
                        <Popover
                          content={
                            <div>
                              <TextArea
                                value={inputList[i]['rootcause']}
                                rows={5}
                                maxLength="150"
                                onChange={(e) =>
                                  handleTextAreaChange(e, i, 'inputList', 'rootcause')
                                }
                              />
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                onClick={() => {
                                  handlePopoverOnclick(
                                    i,
                                    'inputList',
                                    'close',
                                    'rootcause',
                                    'rootCause'
                                  );
                                }}>
                                {translation('Cancel')}
                              </span>
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                onClick={() => {
                                  handlePopoverOnclick(i, 'inputList', 'ok', 'rootCause');
                                }}>
                                {translation('Ok')}
                              </span>
                            </div>
                          }
                          open={rootCause}
                          onOpenChange={(value) => handleVisibleChange(value, 'rootCause')}
                          title={
                            translationCache && translationCache[`${constants.rootcauseanalysis}`]
                              ? translationCache[`${constants.rootcauseanalysis}`]
                              : `${constants.rootcauseanalysis}`
                          }
                          trigger="click">
                          <TextParagraph>
                            {translationCache &&
                              translationCache[`${constants.rootcauseanalysis}`]
                              ? translationCache[`${constants.rootcauseanalysis}`]
                              : `${constants.rootcauseanalysis}`}
                          </TextParagraph>
                          {inputList[i]['rootcause'] && inputList[i]['rootcause'].length > 0 ? (
                            <span style={{ color: '#60c40e' }}>
                              <CheckCircleOutlined />
                            </span>
                          ) : null}
                        </Popover>
                        <Popover
                          content={
                            <div>
                              <TextArea
                                value={inputList[i]['recommandation']}
                                rows={5}
                                maxLength="150"
                                onChange={(e) =>
                                  handleTextAreaChange(e, i, 'inputList', 'recommandation')
                                }
                              />
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                onClick={() => {
                                  handlePopoverOnclick(
                                    i,
                                    'inputList',
                                    'close',
                                    'recommandation',
                                    'recommandationStatus'
                                  );
                                }}>
                                {translation('Cancel')}
                              </span>
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                onClick={() => {
                                  handlePopoverOnclick(
                                    i,
                                    'inputList',
                                    'ok',
                                    'recommandationStatus'
                                  );
                                }}>
                                {translation('Ok')}
                              </span>
                            </div>
                          }
                          open={recommandationStatus}
                          onOpenChange={(value) =>
                            handleVisibleChange(value, 'recommandationStatus')
                          }
                          title={
                            translationCache && translationCache[`${constants.recomandations}`]
                              ? translationCache[`${constants.recomandations}`]
                              : `${constants.recomandations}`
                          }
                          trigger="click">
                          <TextParagraph>
                            {translationCache && translationCache[`${constants.recomandations}`]
                              ? translationCache[`${constants.recomandations}`]
                              : `${constants.recomandations}`}
                            {inputList[i]['recommandation'] &&
                              inputList[i]['recommandation'].length > 0 ? (
                              <span style={{ color: '#60c40e' }}>
                                <CheckCircleOutlined />
                              </span>
                            ) : null}
                          </TextParagraph>
                        </Popover>
                      </Fragment>
                    )}
                  </ButtonBoxDiv>
                  {i === inputList.length - 1 && (
                    <div>
                      <Row>
                        <Col span={10}>
                          <ActionSelectionDiv>
                            <BlockedLabelBlack>
                              {translation(constants.action)}
                              <span style={{ color: 'red' }}>*</span>
                            </BlockedLabelBlack>
                            <ActionCheckbox
                              options={data}
                              value={config.inputList[i]['action']}
                              onChange={(checkedValues) => {
                                checkonChange(checkedValues, 'inputList', i);
                              }}
                            />
                            <Popover placement="top" title={'Delay'}>
                              <TimePicker
                                style={{ margin: '10px' }}
                                defaultValue={dayjs('00:00:00', 'HH:mm:ss')}
                                value={
                                  config.inputList &&
                                    config.inputList[i] &&
                                    config.inputList[i]['delay'] === undefined
                                    ? dayjs('00:00:00', 'HH:mm:ss')
                                    : dayjs(config.inputList[i]['delay'][1], 'HH:mm:ss')
                                }
                                onChange={(e) => handleDelay(e, 'inputList', i)}
                                placeholder={translation(constants.selectDelay)}
                                allowClear={false}
                              />
                            </Popover>
                            {config &&
                              config.inputList &&
                              config.inputList[config.inputList.length - 1] &&
                              config.inputList[config.inputList.length - 1].cation &&
                              config.inputList[config.inputList.length - 1].action.indexOf(
                                'RestAPI'
                              ) > -1 ? (
                              <Input
                                style={{ width: '55%', marginTop: '2%' }}
                                placeholder="Enter Url"
                                name="value"
                                value={props.url}
                                onChange={(e) => handleurl(e, 'url')}
                              />
                            ) : null}
                          </ActionSelectionDiv>
                        </Col>
                      </Row>
                    </div>
                  )}
                  {i === inputList.length - 1 && (
                    <div>
                      <Row>
                        <Col span={10}>
                          <ActionSelectionDiv>
                            <BlockedLabelBlack>
                              {translationCache &&
                                translationCache[`${constants.NotificationType}`]
                                ? translationCache[`${constants.NotificationType}`]
                                : `${constants.NotificationType}`}
                            </BlockedLabelBlack>
                            {ruleType !== 'downTime' && (
                              <OnchangeCheckbox
                                checked={onContinous}
                                disabled={onChange}
                                onChange={(value) => handleContinous(value)}>
                                {translationCache && translationCache[`${constants.onContinous}`]
                                  ? translationCache[`${constants.onContinous}`]
                                  : `${constants.onContinous}`}
                              </OnchangeCheckbox>
                            )}
                            <Popover placement="top" title={'Frequency'}>
                              <TimePicker
                                disabled={!onContinous}
                                style={{ margin: '10px' }}
                                defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                value={
                                  config.inputList &&
                                    config.inputList[i] &&
                                    config.inputList[i]['frequency'] === undefined
                                    ? dayjs('00:00:00', 'HH:mm:ss')
                                    : dayjs(config.inputList[i]['frequency'][1], 'HH:mm:ss')
                                }
                                onChange={(e) => handleFrequency(e, 'inputList', i)}
                                placeholder={
                                  translationCache &&
                                    translationCache[`${constants.selectFrequency}`]
                                    ? translationCache[`${constants.selectFrequency}`]
                                    : `${constants.selectFrequency}`
                                }
                                allowClear={false}
                              />
                            </Popover>
                            {config &&
                              config.inputList &&
                              config.inputList[config.inputList.length - 1] &&
                              config.inputList[config.inputList.length - 1].cation &&
                              config.inputList[config.inputList.length - 1].action.indexOf(
                                'RestAPI'
                              ) > -1 ? (
                              <Input
                                style={{ width: '55%', marginTop: '2%' }}
                                placeholder="Enter Url"
                                name="value"
                                value={props.url}
                                onChange={(e) => handleurl(e, 'url')}
                              />
                            ) : null}
                          </ActionSelectionDiv>
                        </Col>
                      </Row>
                    </div>
                  )}
                  {i === inputList.length - 1 && (
                    <div>
                      <Row>
                        <Col span={7}>
                          <BlockedLabelBlack>
                            {translationCache &&
                              translationCache[`${constants.noOfNotifications}`]
                              ? translationCache[`${constants.noOfNotifications}`]
                              : `${constants.noOfNotifications}`}
                          </BlockedLabelBlack>
                          <Input
                            type="number"
                            onKeyDown={(e) => {
                              if ([8].includes(e.keyCode)) {
                                return;
                              }
                              if (
                                (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                (e.keyCode < 96 || e.keyCode > 105)
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder={translation('No.of Notifications')}
                            value={NumberOfNotifications}
                            style={{ width: '100%', display: 'inline-block' }}
                            onChange={(value) =>
                              handleNotificationChange(value, 'NumberOfNotifications')
                            }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col span={7}>
                          <BlockedLabelBlack>
                            {translationCache && translationCache[`${constants.members}`]
                              ? translationCache[`${constants.members}`]
                              : `${constants.members}`}
                          </BlockedLabelBlack>
                          <Select
                            placeholder={translation('RecipientList')}
                            mode="multiple"
                            value={mailRecipients}
                            style={{ width: '100%', display: 'inline-block' }}
                            onChange={(value) => handleRecipientList(value, 'mailRecipients')}>
                            {recipientList &&
                              Array.isArray(recipientList) &&
                              recipientList.map((item, index) => (
                                <Option key={index} value={item.Email}>
                                  {item.FirstName} {item.LastName}
                                </Option>
                              ))}
                          </Select>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Boxdiv>
              );
            })
            : null}
          {/* -------------------- Else if */}
          {conelseif
            ? elsifLength.map((elsepropName, index) => {
              return config[elsepropName].map((x, i) => {
                return (
                  <Boxdiv key={`${index}${i}`}>
                    {i === 0 ? <BlockedLabelBlack>else if</BlockedLabelBlack> : null}
                    {i > 0 && (
                      <ConditionSelect
                        name="operater"
                        value={inputList[i]['54765'] === '' ? undefined : inputList[i]['54765']}
                        placeholder={
                          translationCache && translationCache[`${constants.selectCondition}`]
                            ? translationCache[`${constants.selectCondition}`]
                            : `${constants.selectCondition}`
                        }
                        onChange={(e) => handleConditionchange(e, i, 'elsepropName')}>
                        <Option value="&&">AND</Option>
                        <Option value="||">OR</Option>
                      </ConditionSelect>
                    )}
                    <ParameterSelect
                      // disabled={edit || (inputList.length > 1 && !edit)}
                      name="parameterName"
                      placeholder={translation(constants.ParameterType)}
                      value={props.parameterName}
                      onChange={(value) => {
                        handleParameterSelect(value, i, 'elsepropName');
                        handleSelectHierarchy(
                          inputList[i].HierarchyId === undefined
                            ? hierarchyDefault
                            : inputList[i].HierarchyId,
                          i,
                          'elsepropName',
                          value
                        );
                      }}>
                      {props.parameterChangeList &&
                        Array.isArray(props.parameterChangeList) &&
                        props.parameterChangeList.map((parameter, j) => (
                          <Option
                            key={`elseifdeviceList${j}`}
                            value={parameter.ParameterType}
                            disabled={parameter.ParameterType === 'Operational'}>
                            {parameter.ParameterType}
                          </Option>
                        ))}
                    </ParameterSelect>
                    <ParameterSelect
                      disabled={edit || (inputList.length > 1 && !edit)}
                      name="selectedHierarchy"
                      onChange={(value) =>
                        handleSelectHierarchy(
                          value,
                          i,
                          'elsepropName',
                          inputList[i].parameterName === ''
                            ? undefined
                            : inputList[i].parameterName
                        )
                      }
                      placeholder={translation('Please select hierarchy')}
                      value={
                        inputList[i].HierarchyId === undefined
                          ? hierarchyDefault
                          : inputList[i].HierarchyId
                      }>
                      {selectedHierarchy &&
                        Array.isArray(selectedHierarchy) &&
                        selectedHierarchy.map((item, j) => (
                          <Option key={j} value={item.HierarchyCode}>
                            {item.HierarchyName}
                          </Option>
                        ))}
                    </ParameterSelect>
                    <DeviceSelect
                      placeholder={
                        translationCache && translationCache[`${constants.device}`]
                          ? translationCache[`${constants.device}`]
                          : `${constants.device}`
                      }
                      value={props.selectedDevices || inputList[i].device}
                      disabled={true}
                      suffixIcon={
                        <ApartmentOutlined
                          style={{
                            color: '#1a3b5c',
                            cursor: disabledParamTypeDevice ? 'not-allowed' : 'pointer',
                            opacity: disabledParamTypeDevice ? '0.3' : '1'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            if (edit || (inputList.length > 1 && !edit)) {
                              setTreeVisible(false);
                            } else {
                              if (inputList[i] && !inputList[i].parameterName) {
                                setTreeVisible(false);
                                message.error(translation('Please Select ParameterType'));
                              } else {
                                setTreeVisible(true);
                              }
                            }
                          }}
                        />
                      }>
                      {deviceList &&
                        Array.isArray(deviceList) &&
                        deviceList.map((device, j) => (
                          <Option key={`ifdeviceList${j}`} value={device.AliasCode}>
                            {device.Name}
                          </Option>
                        ))}
                    </DeviceSelect>
                    <TagNameSelect
                      showSearch
                      name="tagName"
                      placeholder={
                        translationCache && translationCache[`${constants.selectparameters}`]
                          ? translationCache[`${constants.selectparameters}`]
                          : `${constants.selectparameters}`
                      }
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      value={inputList[i].tagName === '' ? undefined : inputList[i].tagName}
                      onChange={(e) => handleTagSelect(e, i, 'elsepropName')}>
                      {parametersList &&
                        Array.isArray(parametersList) &&
                        parametersList.filter(
                          (param) =>
                            param.ParameterDescription && param.ParameterDescription.trim() !== ''
                        ).map((param, j) => (
                          <Option key={`inputTagname${i}${j}`} value={param.ParameterCode}>
                            {translation(param.ParameterDescription)}
                          </Option>
                        ))}
                    </TagNameSelect>
                    <OperaterSelect
                      name="operater"
                      placeholder={
                        translationCache && translationCache[`${constants.selectoperator}`]
                          ? translationCache[`${constants.selectoperator}`]
                          : `${constants.selectoperator}`
                      }
                      value={inputList[i].operater === '' ? undefined : inputList[i].operater}
                      onChange={(e) => handleInputChange(e, i, 'select', 'elsepropName')}>
                      {Operator.map((item, index) =>
                        config.parameter === 'Operational' ? (
                          <Option key={index} value={item.value}>
                            {item.key}
                          </Option>
                        ) : null
                      )}
                      {config.parameter !== 'Operational' ? (
                        <Option value="==" title="EqualTo">
                          {`EqualTo (==)`}
                        </Option>
                      ) : null}
                    </OperaterSelect>
                    <ValueInput
                      name="value"
                      maxLength={6}
                      placeholder={
                        translationCache && translationCache[`${constants.value}`]
                          ? translationCache[`${constants.value}`]
                          : `${constants.value}`
                      }
                      value={inputList[i].value}
                      onChange={(e) => handleInputChange(e, i, 'input', 'elsepropName')}
                    />
                    {/* <TagNameSelect
                        showSearch
                        name="tagName"
                        
                        placeholder={
                          translationCache && translationCache[`${constants.selectparameters}`]
                            ? translationCache[`${constants.selectparameters}`]
                            : `${constants.selectparameters}`
                        }
                        value={x.tagName === '' ? undefined : x.tagName}
                        onChange={(e) => handleTagSelect(e, i, 'elsepropName')}
                      >
                        {parametersList && Array.isArray(parametersList) && parametersList
                          // .filter((param) => param.DeviceId === x.device)
                          .map((param, j) => {
                            return (
                              <Option
                                key={`${elsepropName}Tagname${i}${j}`}
                                value={param.ParameterCode}
                              >
                                {`${param.TagID}:${param.ParameterCode}`}
                              </Option>
                            );
                          })}
                      </TagNameSelect>
                      <OperaterSelect
                        
                        value={x.operater === '' ? undefined : x.operater}
                        name="operater"
                        placeholder={
                          translationCache &&
                            translationCache[`${constants.selectoperator}`] &&
                            translationCache[`${constants.selectoperator}`]
                            ? translationCache[`${constants.selectoperator}`]
                            : `${constants.selectoperator}`
                        }
                        onChange={(e) => handleInputChange(e, i, 'select', elsepropName)}
                      >
                        <Option value="==" title="EqualTo">
                          ==
                        </Option>
                        <Option value="!=" title="Not EqualTo">
                          !=
                        </Option>
                        <Option value=">" title="Greater Than">
                          {'>'}
                        </Option>
                        <Option value="<" title="Less Than">
                          {'<'}
                        </Option>
                        <Option value=">=" title="Greater Than Or EqualTo">
                          {'>='}
                        </Option>
                        <Option value="<=" title="Less Than Or Equal To">
                          {'<='}
                        </Option>
                      </OperaterSelect>
                      <ValueInput
                        name="value"
                        
                        maxLength={6}
                        placeholder={
                          translationCache &&
                            translationCache[`${constants.value}`] &&
                            translationCache[`${constants.value}`]
                            ? translationCache[`${constants.value}`]
                            : `${constants.value}`
                        }
                        value={x.value}
                        onChange={(e) => handleInputChange(e, i, 'input', elsepropName)}
                      /> */}
                    <ButtonBoxDiv>
                      {config[elsepropName].length !== 1 && (
                        <MarginRightButton onClick={() => handleRemoveClick(i, elsepropName)}>
                          <DeleteOutlined />
                        </MarginRightButton>
                      )}
                      {config[elsepropName].length - 1 === i && (
                        <Fragment>
                          <LogicAddButton
                            type={'primary'}
                            onClick={() => handleAddClick(elsepropName, props.ruleType)}>
                            {translation(constants.add)}
                          </LogicAddButton>
                          <Popover
                            content={
                              <div>
                                <TextArea
                                  value={config[elsepropName][i]['preventive']}
                                  rows={5}
                                  maxLength="150"
                                  onChange={(e) =>
                                    handleTextAreaChange(e, i, elsepropName, 'preventive')
                                  }
                                />
                                <span
                                  style={{ color: '#1890ff', cursor: 'pointer' }}
                                  onClick={() => {
                                    handlePopoverOnclick(
                                      i,
                                      elsepropName,
                                      'close',
                                      'preventive',
                                      `previsible${elsepropName}`
                                    );
                                  }}>
                                  {translation('Cancel')}
                                </span>
                                <span
                                  style={{
                                    color: '#1890ff',
                                    cursor: 'pointer',
                                    float: 'right'
                                  }}
                                  onClick={() => {
                                    handlePopoverOnclick(
                                      i,
                                      elsepropName,
                                      'ok',
                                      `previsible${elsepropName}`
                                    );
                                  }}>
                                  {translation('Ok')}
                                </span>
                              </div>
                            }
                            open={config[`previsible${elsepropName}`]}
                            onOpenChange={(value) =>
                              handleVisibleChange(value, `previsible${elsepropName}`)
                            }
                            title={translation(constants.preventivemeasure)}
                            trigger="click">
                            <TextParagraph>
                              {translation(constants.preventivemeasure)}
                            </TextParagraph>
                            {config[elsepropName][i]['preventive'] &&
                              config[elsepropName][i]['preventive'].length > 0 ? (
                              <span style={{ color: '#60c40e' }}>
                                <CheckCircleOutlined />
                              </span>
                            ) : null}
                          </Popover>
                          <Popover
                            content={
                              <div>
                                <TextArea
                                  value={config[elsepropName][i]['rootcause']}
                                  rows={5}
                                  maxLength="150"
                                  onChange={(e) =>
                                    handleTextAreaChange(e, i, elsepropName, 'rootcause')
                                  }
                                />
                                <span
                                  style={{ color: '#1890ff', cursor: 'pointer' }}
                                  onClick={() => {
                                    handlePopoverOnclick(
                                      i,
                                      elsepropName,
                                      'close',
                                      'rootcause',
                                      `elseifroot${elsepropName}`
                                    );
                                  }}>
                                  {translation('Cancel')}
                                </span>
                                <span
                                  style={{
                                    color: '#1890ff',
                                    cursor: 'pointer',
                                    float: 'right'
                                  }}
                                  onClick={() => {
                                    handlePopoverOnclick(
                                      i,
                                      elsepropName,
                                      'ok',
                                      `elseifroot${elsepropName}`
                                    );
                                  }}>
                                  {translation('Ok')}
                                </span>
                              </div>
                            }
                            open={config[`elseifroot${elsepropName}`]}
                            onOpenChange={(value) =>
                              handleVisibleChange(value, `elseifroot${elsepropName}`)
                            }
                            title={translation(constants.rootcauseanalysis)}
                            trigger="click">
                            <TextParagraph>
                              {translation(constants.rootcauseanalysis)}
                            </TextParagraph>
                            {config[elsepropName][i]['rootcause'] &&
                              config[elsepropName][i]['rootcause'].length > 0 ? (
                              <span style={{ color: '#60c40e' }}>
                                <CheckCircleOutlined />
                              </span>
                            ) : null}
                          </Popover>
                          <Popover
                            content={
                              <div>
                                <TextArea
                                  value={config[elsepropName][i]['recommandation']}
                                  rows={5}
                                  maxLength="150"
                                  onChange={(e) =>
                                    handleTextAreaChange(e, i, elsepropName, 'recommandation')
                                  }
                                />
                                <span
                                  style={{ color: '#1890ff', cursor: 'pointer' }}
                                  onClick={() => {
                                    handlePopoverOnclick(
                                      i,
                                      elsepropName,
                                      'close',
                                      'recommandation',
                                      `elseifrootr${elsepropName}`
                                    );
                                  }}>
                                  {translation('Cancel')}
                                </span>
                                <span
                                  style={{
                                    color: '#1890ff',
                                    cursor: 'pointer',
                                    float: 'right'
                                  }}
                                  onClick={() => {
                                    handlePopoverOnclick(
                                      i,
                                      elsepropName,
                                      'ok',
                                      `elseifrecom${elsepropName}`
                                    );
                                  }}>
                                  {translation('Ok')}
                                </span>
                              </div>
                            }
                            open={config[`elseifrecom${elsepropName}`]}
                            onOpenChange={(value) =>
                              handleVisibleChange(value, `elseifrecom${elsepropName}`)
                            }
                            title={translation(constants.recomandations)}
                            trigger="click">
                            <TextParagraph>{translation(constants.recomandations)}</TextParagraph>
                            {config[elsepropName][i]['recommandation'] &&
                              config[elsepropName][i]['recommandation'].length > 0 ? (
                              <span style={{ color: '#60c40e' }}>
                                <CheckCircleOutlined />
                              </span>
                            ) : null}
                          </Popover>
                        </Fragment>
                      )}
                    </ButtonBoxDiv>
                    {config[elsepropName].length - 1 === i && (
                      <ActionSelectionDiv>
                        <BlockedLabelBlack>
                          {translation(constants.action)}
                          <span style={{ color: 'red' }}>*</span>
                        </BlockedLabelBlack>
                        <ActionCheckbox
                          options={data}
                          value={config[elsepropName][i]['action']}
                          onChange={(checkedValues) => {
                            checkonChange(checkedValues, elsepropName, i);
                          }}
                        />
                        <Popover placement="top" title={'Delay'}>
                          <TimePicker
                            style={{ margin: '10px' }}
                            defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                            value={
                              config[elsepropName][i]['delay'] === undefined
                                ? undefined
                                : dayjs(config[elsepropName][i]['delay'][1], 'HH:mm:ss')
                            }
                            onChange={(e) => handleDelay(e, elsepropName, i)}
                            placeholder={translation(constants.selectDelay)}
                            allowClear={false}
                          />
                        </Popover>
                        <Popover placement="top" title={'Frequency'}>
                          <TimePicker
                            // disabled={!onContinous}
                            style={{ margin: '10px' }}
                            defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                            value={
                              config[elsepropName][i]['frequency'] === undefined
                                ? undefined
                                : dayjs(config[elsepropName][i]['frequency'][1], 'HH:mm:ss')
                            }
                            onChange={(e) => handleFrequency(e, elsepropName, i)}
                            placeholder={translation(constants.selectFrequency)}
                            allowClear={false}
                          />
                        </Popover>
                        {config[elsepropName][i].action.indexOf('RestAPI') > -1 && (
                          <Input
                            style={{ width: '55%', marginTop: '2%' }}
                            placeholder="Enter Url"
                            name="value"
                            value={props.url}
                            onChange={(e) => handleurl(e, 'url')}
                          />
                        )}
                      </ActionSelectionDiv>
                    )}
                    {i === config[elsepropName].length - 1 && (
                      <div>
                        <Row>
                          <Col span={7}>
                            <BlockedLabelBlack>
                              {translationCache &&
                                translationCache[`${constants.noOfNotifications}`]
                                ? translationCache[`${constants.noOfNotifications}`]
                                : `${constants.noOfNotifications}`}
                            </BlockedLabelBlack>
                            <Input
                              type="number"
                              onKeyDown={(e) => {
                                if ([8].includes(e.keyCode)) {
                                  return;
                                }
                                if (
                                  (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                  (e.keyCode < 96 || e.keyCode > 105)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder={translation('No.of Notifications')}
                              value={NumberOfNotifications}
                              style={{ width: '100%', display: 'inline-block' }}
                              onChange={(value) =>
                                handleNotificationChange(value, 'NumberOfNotifications')
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={7}>
                            <BlockedLabelBlack>
                              {translation(constants.members)}
                            </BlockedLabelBlack>
                            <Select
                              placeholder={translation('RecipientList')}
                              mode="multiple"
                              value={mailRecipients}
                              style={{ width: '90%', display: 'inline-block' }}
                              onChange={(value) => handleRecipientList(value, 'mailRecipients')}>
                              {recipientList &&
                                Array.isArray(recipientList) &&
                                recipientList.map((item, index) => (
                                  <Option key={index} value={item.Email}>
                                    {item.FirstName} {item.LastName}
                                  </Option>
                                ))}
                            </Select>
                          </Col>
                          <Col span={6}>
                            <BlockedLabelBlack>
                              {translationCache && translationCache[`${constants.bodymessage}`]
                                ? translationCache[`${constants.bodymessage}`]
                                : `${constants.bodymessage}`}
                            </BlockedLabelBlack>
                            <TextArea
                              name="value"
                              rows={1}
                              value={rulebody}
                              placeholder={translation(constants.text)}
                              onChange={(e) => handleRulebody(e, 'rulebody')}
                            />
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Boxdiv>
                );
              });
            })
            : null}
          {/* -------------------- Else */}
          {conelse
            ? elseList.map((x, i) => {
              return (
                <Boxdiv key={`else${i}`}>
                  {i === 0 ? <BlockedLabelBlack>else</BlockedLabelBlack> : null}
                  {i > 0 && (
                    <ConditionSelect
                      name="operater"
                      value={inputList[i]['54765'] === '' ? undefined : inputList[i]['54765']}
                      placeholder={
                        translationCache && translationCache[`${constants.selectCondition}`]
                          ? translationCache[`${constants.selectCondition}`]
                          : `${constants.selectCondition}`
                      }
                      onChange={(e) => handleConditionchange(e, i, 'elseList')}>
                      <Option value="&&">AND</Option>
                      <Option value="||">OR</Option>
                    </ConditionSelect>
                  )}
                  <ParameterSelect
                    // disabled={edit || (inputList.length > 1 && !edit)}
                    name="parameterName"
                    placeholder={
                      translationCache && translationCache[`${constants.ParameterType}`]
                        ? translationCache[`${constants.ParameterType}`]
                        : `${constants.ParameterType}`
                    }
                    value={props.parameterName}
                    onChange={(value) => {
                      handleParameterSelect(value, i, 'elsepropName');
                      handleSelectHierarchy(
                        inputList[i].HierarchyId === undefined
                          ? hierarchyDefault
                          : inputList[i].HierarchyId,
                        i,
                        'elsepropName',
                        value
                      );
                    }}>
                    {props.parameterChangeList &&
                      Array.isArray(props.parameterChangeList) &&
                      props.parameterChangeList.map((parameter, j) => (
                        <Option
                          key={`elseifdeviceList${j}`}
                          value={parameter.ParameterType}
                          disabled={parameter.ParameterType !== 'Operational'}>
                          {parameter.ParameterType}
                        </Option>
                      ))}
                  </ParameterSelect>
                  <ParameterSelect
                    disabled={edit || (inputList.length > 1 && !edit)}
                    name="selectedHierarchy"
                    onChange={(value) =>
                      handleSelectHierarchy(
                        value,
                        i,
                        'elsepropName',
                        null,
                        inputList[i].parameterName === '' ? undefined : inputList[i].parameterName
                      )
                    }
                    placeholder={translation('Please select hierarchy')}
                    value={
                      inputList[i].HierarchyId === undefined
                        ? hierarchyDefault
                        : inputList[i].HierarchyId
                    }>
                    {selectedHierarchy &&
                      Array.isArray(selectedHierarchy) &&
                      selectedHierarchy.map((item, j) => (
                        <Option key={j} value={item.HierarchyCode}>
                          {item.HierarchyName}
                        </Option>
                      ))}
                  </ParameterSelect>
                  <DeviceSelect
                    placeholder={
                      translationCache && translationCache[`${constants.device}`]
                        ? translationCache[`${constants.device}`]
                        : `${constants.device}`
                    }
                    value={props.selectedDevices || downtimeinputList.device}
                    // disabled={true}
                    suffixIcon={
                      <ApartmentOutlined
                        style={{
                          color: '#1a3b5c',
                          cursor: disabledParamTypeDevice ? 'not-allowed' : 'pointer',
                          opacity: disabledParamTypeDevice ? '0.3' : '1'
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (edit || (inputList.length > 1 && !edit)) {
                            setTreeVisible(false);
                          } else {
                            if (inputList[i] && !inputList[i].parameterName) {
                              setTreeVisible(false);
                              message.error(translation('Please Select ParameterType'));
                            } else {
                              setTreeVisible(true);
                            }
                          }
                        }}
                      />
                    }>
                    {deviceList &&
                      Array.isArray(deviceList) &&
                      deviceList.map((device, j) => (
                        <Option key={`ifdeviceList${j}`} value={device.AliasCode}>
                          {device.Name}
                        </Option>
                      ))}
                  </DeviceSelect>
                  <TagNameSelect
                    showSearch
                    name="tagName"
                    placeholder={translation(constants.selectoperator)}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    value={inputList[i].tagName === '' ? undefined : inputList[i].tagName}
                    onChange={(e) => handleTagSelect(e, i, 'elsepropName')}>
                    {props.parametersList &&
                      Array.isArray(props.parametersList) &&
                      props.parametersList.filter(
                        (param) =>
                          param.ParameterDescription && param.ParameterDescription.trim() !== ''
                      ).map((param, j) => (
                        <Option key={`inputTagname${i}${j}`} value={param.ParameterCode}>
                          {translation(param.ParameterDescription)}
                        </Option>
                      ))}
                  </TagNameSelect>
                  <OperaterSelect
                    name="operater"
                    placeholder={translation(constants.selectoperator)}
                    value={inputList[i].operater === '' ? undefined : inputList[i].operater}
                    onChange={(e) => handleInputChange(e, i, 'select', 'elsepropName')}>
                    {Operator &&
                      Array.isArray(Operator) &&
                      Operator.map((item, index) =>
                        config.parameter === 'Operational' ? (
                          <Option key={index} value={item.value}>
                            {item.key}
                          </Option>
                        ) : null
                      )}
                    {config.parameter !== 'Operational' ? (
                      <Option value="==" title="EqualTo">
                        {`EqualTo (==)`}
                      </Option>
                    ) : null}
                  </OperaterSelect>
                  <ValueInput
                    name="value"
                    maxLength={6}
                    placeholder={
                      translationCache && translationCache[`${constants.value}`]
                        ? translationCache[`${constants.value}`]
                        : `${constants.value}`
                    }
                    value={inputList[i].value}
                    onChange={(e) => handleInputChange(e, i, 'input', 'elsepropName')}
                  />
                  {/* <DeviceSelect
                      placeholder={
                        translationCache &&
                          translationCache[`${constants.device}`] &&
                          translationCache[`${constants.device}`]
                          ? translationCache[`${constants.device}`]
                          : `${constants.device}`
                      }
                      
                      value={x && x.device ? x.device : undefined}
                      onChange={(value) => handledeviceSelect(value, 'elseList', i)}
                    >
                      {deviceList.map((device, i) => {
                        return (
                          <Option key={`elsedeviceList${i}`} value={device.AliasCode}>
                            {device.Name}
                          </Option>
                        );
                      })}
                    </DeviceSelect>
                    <TagNameSelect
                      showSearch
                      name="tagName"
                      
                      placeholder={
                        translationCache &&
                          translationCache[`${constants.selectparameters}`] &&
                          translationCache[`${constants.selectparameters}`]
                          ? translationCache[`${constants.selectparameters}`]
                          : `${constants.selectparameters}`
                      }
                      value={x.tagName === '' ? undefined : x.tagName}
                      onChange={(e) => handleTagSelect(e, i, 'elseList')}
                    >
                      {parametersList && Array.isArray(parametersList) &&  parametersList.map((param, j) => {
                        return (
                          <Option key={`elseListTagname${i}${j}`} value={param.ParameterCode}>
                            {`${param.TagID}:${param.ParameterCode}`}
                          </Option>
                        );
                      })}
                    </TagNameSelect>
                    <OperaterSelect
                      name="operater"
                      
                      placeholder={
                        translationCache &&
                          translationCache[`${constants.selectoperator}`] &&
                          translationCache[`${constants.selectoperator}`]
                          ? translationCache[`${constants.selectoperator}`]
                          : `${constants.selectoperator}`
                      }
                      value={x.operater === '' ? undefined : x.operater}
                      onChange={(e) => handleInputChange(e, i, 'select', 'elseList')}
                    >
                      <Option value="==" title="EqualTo">
                        ==
                      </Option>
                      <Option value="!=" title="Not EqualTo">
                        !=
                      </Option>
                      <Option value=">" title="Greater Than">
                        {'>'}
                      </Option>
                      <Option value="<" title="Less Than">
                        {'<'}
                      </Option>
                      <Option value=">=" title="Greater Than Or EqualTo">
                        {'>='}
                      </Option>
                      <Option value="<=" title="Less Than Or Equal To">
                        {'<='}
                      </Option>
                    </OperaterSelect>
                    <ValueInput
                      
                      name="value"
                      maxLength={6}
                      placeholder={
                        translationCache &&
                          translationCache[`${constants.value}`] &&
                          translationCache[`${constants.value}`]
                          ? translationCache[`${constants.value}`]
                          : `${constants.value}`
                      }
                      value={x.value}
                      onChange={(e) => handleInputChange(e, i, 'input', 'elseList')}
                    />  */}
                  <ButtonBoxDiv>
                    {elseList.length !== 1 && (
                      <MarginRightButton
                        onClick={() => handleRemoveClick(i, 'elseList')}
                        icon={<DeleteOutlined />}>
                        <DeleteOutlined />
                      </MarginRightButton>
                    )}
                    {elseList.length - 1 === i && (
                      <Fragment>
                        <LogicAddButton
                          type={'primary'}
                          onClick={() => handleAddClick('elseList', props.ruleType)}>
                          {translationCache && translationCache[`${constants.add}`]
                            ? translationCache[`${constants.add}`]
                            : `${constants.add}`}
                        </LogicAddButton>
                        <Popover
                          content={
                            <div>
                              <TextArea
                                value={elseList[i]['preventive']}
                                rows={5}
                                maxLength="150"
                                onChange={(e) =>
                                  handleTextAreaChange(e, i, 'elseList', 'preventive')
                                }
                              />
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                onClick={() => {
                                  handlePopoverOnclick(
                                    i,
                                    'elseList',
                                    'close',
                                    'preventive',
                                    `elseprevisible`
                                  );
                                }}>
                                {translation('Cancel')}
                              </span>
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                onClick={() => {
                                  handlePopoverOnclick(i, 'elseList', 'ok', `elseprevisible`);
                                }}>
                                {translation('Ok')}
                              </span>
                            </div>
                          }
                          open={elseprevisible}
                          onOpenChange={(value) => handleVisibleChange(value, `elseprevisible`)}
                          title={
                            translationCache && translationCache[`${constants.preventivemeasure}`]
                              ? translationCache[`${constants.preventivemeasure}`]
                              : `${constants.preventivemeasure}`
                          }
                          trigger="click">
                          <TextParagraph>
                            {translationCache &&
                              translationCache[`${constants.preventivemeasure}`]
                              ? translationCache[`${constants.preventivemeasure}`]
                              : `${constants.preventivemeasure}`}
                          </TextParagraph>
                          {elseList[i]['preventive'] && elseList[i]['preventive'].length > 0 ? (
                            <span style={{ color: '#60c40e' }}>
                              <CheckCircleOutlined />
                            </span>
                          ) : null}
                        </Popover>
                        <Popover
                          content={
                            <div>
                              <TextArea
                                value={elseList[i]['rootcause']}
                                rows={4}
                                maxLength="150"
                                onChange={(e) =>
                                  handleTextAreaChange(e, i, 'elseList', 'rootcause')
                                }
                              />
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                onClick={() => {
                                  handlePopoverOnclick(
                                    i,
                                    'elseList',
                                    'close',
                                    'rootcause',
                                    `elseroot`
                                  );
                                }}>
                                {translation('Cancel')}
                              </span>
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                onClick={() => {
                                  handlePopoverOnclick(i, 'elseList', 'ok', `elseroot`);
                                }}>
                                {translation('Ok')}
                              </span>
                            </div>
                          }
                          open={elseroot}
                          onOpenChange={(value) => handleVisibleChange(value, `elseroot`)}
                          title={
                            translationCache && translationCache[`${constants.rootcauseanalysis}`]
                              ? translationCache[`${constants.rootcauseanalysis}`]
                              : `${constants.rootcauseanalysis}`
                          }
                          trigger="click">
                          <TextParagraph>
                            {translationCache &&
                              translationCache[`${constants.rootcauseanalysis}`]
                              ? translationCache[`${constants.rootcauseanalysis}`]
                              : `${constants.rootcauseanalysis}`}
                          </TextParagraph>
                          {elseList[i]['rootcause'] && elseList[i]['rootcause'].length > 0 ? (
                            <span style={{ color: '#60c40e' }}>
                              <CheckCircleOutlined />
                            </span>
                          ) : null}
                        </Popover>
                        <Popover
                          content={
                            <div>
                              <TextArea
                                value={elseList[i]['recommandation']}
                                rows={4}
                                maxLength="150"
                                onChange={(e) =>
                                  handleTextAreaChange(e, i, 'elseList', 'recommandation')
                                }
                              />
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                onClick={() => {
                                  handlePopoverOnclick(
                                    i,
                                    'elseList',
                                    'close',
                                    'recommandation',
                                    `elserecommandation`
                                  );
                                }}>
                                {translation('Cancel')}
                              </span>
                              <span
                                style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                onClick={() => {
                                  handlePopoverOnclick(i, 'elseList', 'ok', `elserecommandation`);
                                }}>
                                {translation('Ok')}
                              </span>
                            </div>
                          }
                          open={elserecommandation}
                          onOpenChange={(value) =>
                            handleVisibleChange(value, `elserecommandation`)
                          }
                          title={
                            translationCache && translationCache[`${constants.recomandations}`]
                              ? translationCache[`${constants.recomandations}`]
                              : `${constants.recomandations}`
                          }
                          trigger="click">
                          <TextParagraph>
                            {translationCache && translationCache[`${constants.recomandations}`]
                              ? translationCache[`${constants.recomandations}`]
                              : `${constants.recomandations}`}
                          </TextParagraph>
                          {elseList[i]['recommandation'] &&
                            elseList[i]['recommandation'].length > 0 ? (
                            <span style={{ color: '#60c40e' }}>
                              <CheckCircleOutlined />
                            </span>
                          ) : null}
                        </Popover>
                      </Fragment>
                    )}
                  </ButtonBoxDiv>
                  {elseList.length - 1 === i && (
                    <ActionSelectionDiv>
                      <BlockedLabelBlack>
                        {translationCache && translationCache[`${constants.action}`]
                          ? translationCache[`${constants.action}`]
                          : `${constants.action}`}
                        <span style={{ color: 'red' }}>*</span>
                      </BlockedLabelBlack>
                      <ActionCheckbox
                        options={data}
                        value={config.elseList[i]['action'].map((ac) => {
                          return translationCache[ac] ? translationCache[ac] : ac;
                        })}
                        onChange={(checkedValues) => {
                          checkonChange(checkedValues, 'elseList', i);
                        }}
                      />
                      <Popover placement="top" title={'Delay'}>
                        <TimePicker
                          style={{ margin: '10px' }}
                          defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                          value={
                            config.elseList[i]['delay'] === undefined
                              ? undefined
                              : dayjs(config.elseList[i]['delay'][1], 'HH:mm:ss')
                          }
                          onChange={(e) => handleDelay(e, 'elseList', i)}
                          placeholder={
                            translationCache && translationCache[`${constants.selectDelay}`]
                              ? translationCache[`${constants.selectDelay}`]
                              : `${constants.selectDelay}`
                          }
                          allowClear={false}
                        />
                      </Popover>
                      <Popover placement="top" title={'Frequency'}>
                        <TimePicker
                          // disabled={!onContinous}
                          style={{ margin: '10px' }}
                          defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                          value={
                            config.elseList[i]['frequency'] === undefined
                              ? undefined
                              : dayjs(config.elseList[i]['frequency'][1], 'HH:mm:ss')
                          }
                          onChange={(e) => handleFrequency(e, 'elseList', i)}
                          placeholder={
                            translationCache && translationCache[`${constants.selectFrequency}`]
                              ? translationCache[`${constants.selectFrequency}`]
                              : `${constants.selectFrequency}`
                          }
                          allowClear={false}
                        />
                      </Popover>
                      {config &&
                        config.elseList[i] &&
                        config.elseList[i].action.indexOf('RestAPI') > -1 && (
                          <Input
                            style={{ width: '55%', marginTop: '2%' }}
                            placeholder="Enter Url"
                            name="value"
                            value={props.url}
                            onChange={(e) => handleurl(e, 'url')}
                          />
                        )}
                    </ActionSelectionDiv>
                  )}
                  {i === elseList.length - 1 && (
                    <div>
                      <Row>
                        <Col span={7}>
                          <BlockedLabelBlack>
                            {translationCache &&
                              translationCache[`${constants.noOfNotifications}`]
                              ? translationCache[`${constants.noOfNotifications}`]
                              : `${constants.noOfNotifications}`}
                          </BlockedLabelBlack>
                          <Input
                            type="number"
                            onKeyDown={(e) => {
                              if ([8].includes(e.keyCode)) {
                                return;
                              }
                              if (
                                (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                (e.keyCode < 96 || e.keyCode > 105)
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder={translation('No.of Notifications')}
                            value={NumberOfNotifications}
                            style={{ width: '100%', display: 'inline-block' }}
                            onChange={(value) =>
                              handleNotificationChange(value, 'NumberOfNotifications')
                            }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col span={7}>
                          <BlockedLabelBlack>{translation(constants.members)}</BlockedLabelBlack>
                          <Select
                            placeholder={translation('RecipientList')}
                            value={mailRecipients}
                            mode="multiple"
                            style={{ width: '90%', display: 'inline-block' }}
                            onChange={(value) => handleRecipientList(value, 'mailRecipients')}>
                            {recipientList &&
                              Array.isArray(recipientList) &&
                              recipientList.map((item, index) => (
                                <Option key={index} value={item.Email}>
                                  {item.FirstName} {item.LastName}
                                </Option>
                              ))}
                          </Select>
                        </Col>
                        <Col span={5}>
                          <BlockedLabelBlack>
                            {translationCache && translationCache[`${constants.bodymessage}`]
                              ? translationCache[`${constants.bodymessage}`]
                              : `${constants.bodymessage}`}
                          </BlockedLabelBlack>
                          <TextArea
                            name="value"
                            rows={1}
                            value={rulebody}
                            placeholder={
                              translationCache && translationCache[`${constants.text}`]
                                ? translationCache[`${constants.text}`]
                                : `${constants.text}`
                            }
                            onChange={(e) => handleRulebody(e, 'rulebody')}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}
                </Boxdiv>
              );
            })
            : null}
          {/* 
            <AddParagraph
              onClick={handleelse}
              style={{
                pointerEvents: 'none',
                opacity: '0.4'
              }}
            >
              {translationCache && translationCache[`${constants.addelse}`]
                ? translationCache[`${constants.addelse}`]
                : `${constants.addelse}`}
            </AddParagraph>
            <AddParagraph
              onClick={handleelseif}
              style={{
                pointerEvents: 'none',
                opacity: '0.4'
              }}
            >
              {translationCache && translationCache[`${constants.addelseif}`]
                ? translationCache[`${constants.addelseif}`]
                : `${constants.addelseif}`}
            </AddParagraph> */}
          <BlankDiv></BlankDiv>
        </>
      ) : null}
      <StyledModal
        open={visibleTree}
        width={800}
        closable={false}
        title={'Select Equipment for replication'}
        footer={[
          <Button key="submit" type="primary" onClick={onModalsOk}>
            {replicateDevices && replicateDevices.length === 0 ? 'Add' : 'Edit'}
          </Button>
        ]}>
        <HierarchyModal
          replicateDevicesList={replicateDevices}
          checkedValue={checkedValue}
          treeData={onTree(props.treeData)}
          translationCache={translationCache}
          Key="Replicate"
          handleDropdownChange={hierarchyDropdownChanged}
        />
      </StyledModal>
      <StyledModal
        open={treeVisible}
        width={800}
        closable
        title={'Select Equipment'}
        footer={[
          <Button key="back" onClick={onModalCancel}>
            Cancel
          </Button>
        ]}
        onCancel={onModalCancel}>
        <HierarchyModal
          replicateDevicesList={replicateDevices}
          // value={deviceId}
          treeData={props.treeData}
          translationCache={translationCache}
          Key="Rule"
          handleDropdownChange={hierarchyDropdownChange}
        />
      </StyledModal>
    </StyledAppdiv>
  );
};
export default DeviceRule;
